<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
      <div class="col-lg-12" style="padding: 0px">
        <section class="widget">

          <div class="row">
            <div class="col-6">
              <div class="row">
                <button class="btn boton botonXS" (click)="Formulario(1)" *ngIf="sistemaService.permisos.agregar && tienesesion">
                  <span class="fa fa-plus"></span>
                  <span> {{'Crear encuesta'}}</span>
                </button>
                <div class="divisorH16" *ngIf="tienesesion"></div>
                <button class="btn boton botonXS"  *ngIf=" tienesesion" (click)="modal()">
                  <span class="fa fa-envelope-o"></span>
                  <span> {{'Enviar encuesta'}}</span>
                </button>
                <div class="divisorH16" *ngIf="tienesesion"></div>
                <button class="btn boton botonXS" *ngIf="tienesesion" (click)="abrirdrive()">
                  <span class="fa fa-google"></span>
                  <span> {{'Ir a carpeta drive'}}</span>
                </button>
                <div class="divisorH16" *ngIf="tienesesion"></div>
                <button *ngIf="!tienesesion" class="btn boton botonXS" (click)="generarcredenciales()">
                  <span class="fa fa-google"></span>
                  <span> {{'Generar credenciales'}}</span>
                </button>
              </div>
            </div>
            <div class="col-6" style="justify-content: end; display: flex;">
              <div class="tooltip-container">
                <i class="fa fa-question-circle"></i>
                <span class="tooltip">
                  - Estatus "<span class="colorpendiente">Pendiente</span>"" se refiere cuando la encuesta ha sido creada, pero no configurada<br> - Estatus "Pend. Envío" se refiere cuando la encuesta ha sido configurada, pero no enviada<br> - Estatus "<span class="colorenviado">Enviada</span>" se refiere cuando la encuesta ha sido enviada
                </span>
              </div>
            </div>
          </div>


          <div class="divisor16"></div>

          <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="datatable"
                        [hoverStateEnabled]="true"
                        [(selectedRowKeys)]="selectedRows"
                        (onEditorPreparing)="onEditorPreparing($event)"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>
                        <dxo-selection mode="single" [showCheckBoxesMode]="'always'"></dxo-selection>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                        dataField="selected"
                        type="selection"
                        alignment="center">
                        </dxi-column>
                        <dxi-column
                            dataField="nombre"
                            caption="Nombre encuesta">
                        </dxi-column>
                        <dxi-column
                          dataField="encuestados"
                          caption="Encuestados">
                        </dxi-column>
                        <dxi-column
                          dataField="fechacreacion"
                          caption="Fecha de creación">
                        </dxi-column>
                        <!--dxi-column
                          dataField="creadopor"
                          caption="Creado por">
                        </!--dxi-column -->
                        <dxi-column
                          dataField="fechaenvio"
                          caption="Fecha envio">
                        </dxi-column>
                        <dxi-column
                          dataField="ciclo"
                          caption="Ciclo">
                        </dxi-column>
                        <dxi-column
                          dataField="correosenviados"
                          caption="Correos enviados">
                        </dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                            cellTemplate="cellEstatus"
                            caption="Estatus"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a class="tablaBoton" [href]="'https://docs.google.com/forms/d/'+cell.data.formid+'/edit'" target="_blank">
                                <button class="bottonform">
                                  <span>Abrir encuesta</span>
                                </button>
                            </a>
                            <a class="tablaBoton separado delete" (click)="Eliminar(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div *dxTemplate="let cell of 'cellEstatus'">
                          <span style="color: orange;" *ngIf="cell.data.encuestaestatusid == 1">{{cell.data.estatus}}</span>
                          <span *ngIf="cell.data.encuestaestatusid == 2">{{cell.data.estatus}}</span>
                          <span style="color: lightblue;" *ngIf="cell.data.encuestaestatusid == 3">{{cell.data.estatus}}</span>
                          <!-- <span *ngIf="cell.data.encuestaestatusid == 3">Cargado</span> -->
                        </div>

                    </dx-data-grid>
        </section>
    </div>
    </div>
</div>

<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{('Encuestas: Enviar encuesta')}}
                </div>
            </div>
            <div class="modalContenido">
                <div class="row">
                    <div class="col-12" style="display: flex; justify-content: end;" *ngIf="visualizarAlumnos">
                      <div class="tooltip-container">
                        <i class="fa fa-question-circle"></i>
                        <span class="tooltip">
                          - Por default se selecciona el Ciclo escolar actual. En caso de ser necesario, se muestra el ciclo anterior para ser seleccionado. Esto para indicar el ciclo de los evaluadores.
                        </span>
                      </div>
                    </div>
                    <div class="divisor8"></div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6">
                          <inputCustom [titulo]="'Nombre del documento'" [disabled]="true" [(ngModel)]="this.selectedRows[0].nombre"></inputCustom>
                        </div>
                        <div class="col-6">
                          <inputCustom [titulo]="'Titulo de la encuesta'" [disabled]="true" [(ngModel)]="this.selectedRows[0].titulo"></inputCustom>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-3">
                          <dropdownCustom [titulo]="'Evaluadores'"
                          [opciones]="SelEvaluador"
                          [(ngModel)]="enviarEncuesta.evaluadorid"
                          [valorName]="'evaluadorid'"
                          [displayValor]="'nombre'"
                          [multiSelect]="true"
                          [buscar]="false"
                          (ngModelChange)="Evaluador($event)"
                          ></dropdownCustom>
                      </div>
                        <div class="col-3" *ngIf="visualizarAlumnos">
                          <dropdownCustom [titulo]="'Ciclo escolar'"
                          [opciones]="cicloEnvio"
                          [(ngModel)]="enviarEncuesta.cicloid"
                          [valorName]="'cicloid'"
                          [displayValor]="'nombre'"
                          [buscar]="false"
                          ></dropdownCustom>
                        </div>
                        <div class="col-2" *ngIf="visualizarAlumnos">
                          <dropdownCustom [titulo]="'Nivel'"
                          [opciones]="SelNivellista"
                          [(ngModel)]="enviarEncuesta.nivelid"
                          [valorName]="'nivelid'"
                          [displayValor]="'nombre'"
                          [multiSelect]="true"
                          [buscar]="false"
                          [errorActivo]="errornivel"
                          [verError]="errornivel"
                          ></dropdownCustom>
                        </div>
                        <div class="col-2">
                          <datePickerV2Custom [titulo]="'Fecha envío'" [(ngModel)]="enviarEncuesta.fechaenvio"></datePickerV2Custom>
                        </div>
                        <div class="col-2">
                          <timePickerCustom [titulo]="'Hora envío'" [(ngModel)]="enviarEncuesta.horaenvio" ></timePickerCustom>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6">
                          <a class="tablaBoton" [href]="'https://docs.google.com/forms/d/'+selectedRows[0].formid+'/edit'" target="_blank">
                            <button class="bottonform" style="padding: 8px !important; margin: 0 !important; margin-bottom: 8px !important;">
                              <span>Abrir encuesta</span>
                            </button>
                        </a>
                        </div>
                        <div class="col-6" *ngIf="visualizarColaborador">
                          <div class="panelBotonesFiltro">
                              <button class="boton botonSM filled" (click)="Buscar()">
                                  {{'Consultar' | translate}}
                              </button>
                          </div>
                        </div>
                        <div class="col-6" *ngIf="visualizarAlumnos">
                          <div class="panelBotonesFiltro">
                            <button class="boton botonSM filled" (click)="BuscarAlumnos()">
                              {{'Consultar' | translate}}
                          </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                        <div class="row" *ngIf="visualizarColaborador">
                            <div class="divisorgris"></div>
                            <div class="divisor16"></div>

                            <!-- datos -->
                        <dx-data-grid
                        #grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="listaColaborador"
                            [showColumnHeaders]="true"
                            >

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>

                            <dxo-selection
                            [selectAllMode]="'allPages'"
                            [showCheckBoxesMode]="'always'"
                            mode="multiple"
                          ></dxo-selection>

                          <dxi-column
                            dataField="nomina"
                            caption="N° de nómina">
                          </dxi-column>
                          <dxi-column
                            dataField="nombre"
                            caption="Nombre">
                          </dxi-column>
                          <dxi-column
                            dataField="apellidopaterno"
                            caption="Ap. paterno">
                          </dxi-column>
                          <dxi-column
                            dataField="apellidomaterno"
                            caption="Ap. materno">
                          </dxi-column>
                          <dxi-column
                            dataField="departamento"
                            caption="Departamento">
                          </dxi-column>
                          <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                          </dxi-column>
                          <dxi-column
                            dataField="nivel"
                            caption="Nivel">
                          </dxi-column>

                        </dx-data-grid>
                        </div>
                        <div class="row" *ngIf="visualizarAlumnos">
                      <div class="divisorgris"></div>
                      <div class="divisor16"></div>

                      <div class="col-12">
                        <dx-tree-view
                        id="treeview"
                        [height]="500"
                        dataStructure="plain"
                        parentIdExpr="padreid"
                        keyExpr="id"
                        displayExpr="nombre"
                        [searchEnabled]="true"
                        searchMode="contains"
                        [showCheckBoxesMode]="'selectAll'"
                        [selectionMode]="'multiple'"
                        [selectNodesRecursive]="true"
                        [createChildren]="createChildren"
                        hasItemsExpr="isDirectory"
                        >
                        <dxo-search-editor-options placeholder="Buscar">
                        </dxo-search-editor-options>
                    </dx-tree-view>
                      </div>

                        </div>
                    </div>
                </div>

            </div>

            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div #encuestadetalle></div>
